import { Glue42Core } from "@glue42/core";

import manager from "./Manager";
import {Glue42Office} from "../../../glue4office";
import {AttachmentImpl} from "./AttachmentImplementation";
import {getTaskPriority} from "../helpers/index";

export class TaskImpl implements Glue42Office.Outlook.Task {
    public actualWork: number;
    public attachments: Glue42Office.Outlook.Attachment[];
    public body: string;
    public creationTime: Date;
    public dateCompleted: Date;
    public dueDate: Date;
    public ids: Glue42Office.Outlook.T42Id[];
    public priority: string;
    public reminderTime: Date;
    public startDate: Date;
    public subject: string;
    public entityType: number;

    constructor(task: Glue42Office.Outlook.T42Task, agm: Glue42Core.AGM.API) {
        if (task.attachments && task.attachments.length > 0) {
            this.attachments = [];
            task.attachments.forEach((att: Glue42Office.Outlook.T42Attachment) => {
                this.attachments.push(new AttachmentImpl(att, agm, this));
            });
        }
        this.actualWork = task.actualWork;
        this.body = task.body;
        this.creationTime = task.creationTime;
        this.dateCompleted = task.dateCompleted;
        this.dueDate = task.dueDate;
        this.ids = task.ids;
        this.priority = getTaskPriority(task.importance);
        this.reminderTime = task.reminderTime;
        this.startDate = task.startDate;
        this.subject = task.subject;
        this.entityType = task.entityType;
    }

    public show(): Promise<Glue42Office.Outlook.T42Id[]> {
        return manager.showItemMethod(this.ids, "showTask");
    }

    public saveToFile(): Promise<string> {
        return manager.saveItemMethod(this.ids, "saveTask");
    }
}
